import { MutationTree } from 'vuex'
import { ProcedureState } from './ProcedureState'
import { ProcedureDto } from '@/Application/Procedures'
import store from '@/Infrastructure/Store'
import { BatchDto } from '@/Application/Batch'

export const mutations: MutationTree<ProcedureState> = {
  setCurrentProcedure (state: ProcedureState, payload: ProcedureDto) {
    if (state.currentProcedure !== payload) {
      store.dispatch('auctionb/clearAuctionAll')
      state.currentProcedure = payload
    }
  },
  setRiscoBatches (state: ProcedureState, payload: BatchDto[]) {
    state.riscoBatches = payload
  },
  setResultasBatches (state: ProcedureState, payload: BatchDto[]) {
    state.resultasBatches = payload
  }
}
